//------------------------------------------------------------------------------
// BFA10103G 共架申込 機器設備 - 地図/ポップアップ
//------------------------------------------------------------------------------
/**
 * ポップアップを閉じる
 */
export default function closePopup(view) {
  view.closePopup();
}
